<div class="row justify-content-center" xmlns="http://www.w3.org/1999/html">
  <div class="col mt-5">
    <div class="text-center" *ngIf="!setApplicationLoading">
      <div *ngIf="instantIssue === true && !applicationDenied" class="col mb-5">
        <h1>{{ "onboarding.preApproved.congrats" | translate: {Default: "Felicidades!!!"} }}</h1>
        <p>{{ "onboarding.preApproved.accountApproved" | translate: {Default: "Tu cuenta ha sido aprobada."} }}</p>
      </div>
      <div *ngIf="instantIssue === false && !applicationDenied" class="col mb-5">
        <h1>{{ "onboarding.preApproved.congrats-instant-issue" | translate: {Default: "¡¡Felicidades!!"} }}</h1>
        <p>{{ "onboarding.preApproved.application-instant-issue" | translate: {Default: "Tu solicitud fue enviada."} }}</p>
      </div>
      <div *ngIf="this.appRejected" class="col mb-5">
        <h1>{{ "onboarding.end.thanks" | translate: {Default: "¡Gracias!"} }}</h1>
        <p>{{ "onboarding.end.dataUpdated" | translate: {Default: "Hemos actualizado tu solicitud."} }}</p>
      </div>
      <div *ngIf="applicationDenied" class="col mb-5">
        <h1>{{ "onboarding.end.apologies" | translate: {Default: "Lo sentimos."} }}</h1>
        <p>{{ "onboarding.end.notElegible" | translate: {Default: "No eres candidato para este producto."} }}</p>
      </div>
    </div>

    <div *ngIf="!applicationDenied && !setApplicationLoading" class="panel">
      <div class="card-img card-img--front" [ngClass]="{'card-img__text_stroked': this.cardTextStroked, 'card-img__bordered': borderCard, 'card-img__text-white': textWhiteCard}">

        <div class="card-img__number">{{card | mask : '0000 0000 AAAA AAAA'}}</div>
        <div class="card-img__owner">{{this.name}}</div>
        <img class="card-img__logo" height="37.5" src="assets/images/mastercard.png"/>
      </div>
      <div class="row justify-content-center">
        <p *ngIf="this.responseServicesOk" [innerHTML]="'onboarding.end.final_message' | translate"></p>
        <p *ngIf="!this.responseServicesOk" >{{ "onboarding.end.final_message_card" | translate }}</p>
      </div>
    </div>
    <div *ngIf="!applicationDenied && setApplicationLoading" class="panel">
      <div class="row justify-content-center">
        <div class="card justify-content-center mb-2 p-0 col-6" style="border-color: var(--info); border-radius: 15px">
          <div class="row no-gutters">
            <div class="col-2 col-sm-1 d-flex justify-content-center align-items-center p-0 m-0">
              <i class="fa fa-lg text-info fa-info-circle"></i>
            </div>
            <div class="col-10 col-sm-11 d-flex justify-content-center align-items-center p-0 m-0">
              <div class="card-body p-0">
                <p class="card-text responsive-small text-info" style="font-size: 15px">
                  {{ "onboarding.end.loading_card_message" | translate }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p-skeleton class="row justify-content-center mb-3" width="20rem" height="2rem" borderRadius="15px" > </p-skeleton>
      <p-skeleton class="row justify-content-center mb-5" width="18rem" height="1rem" borderRadius="15px" > </p-skeleton>
      <p-skeleton width="318.75px" height="202.5px" borderRadius="15px" class="skeleton_card"> </p-skeleton>
      <p-skeleton class="row justify-content-center" width="40rem" height="1rem" borderRadius="15px" > </p-skeleton>
      <p-skeleton class="row justify-content-center mt-2" width="40rem" height="1rem" borderRadius="15px" > </p-skeleton>
      <p-skeleton class="row justify-content-center mt-2" width="20rem" height="1rem" borderRadius="15px" > </p-skeleton>
    </div>
    <div class="row justify-content-center" *ngIf="!setApplicationLoading">
      <button *ngIf="applicationDenied" class="btn btn-primary text-white" (click)="finish()">{{ "onboarding.end.finalize" | translate: {Default: "Finalizar"} }}</button>
      <button *ngIf="!applicationDenied" class="btn btn-outline-primary" (click)="finishLogin()">{{ "onboarding.end.goHome1" | translate: {Default: "Ir a la pantalla de inicio"} }}</button>
    </div>
  </div>
</div>